import { render, staticRenderFns } from "./compChannelConfig.vue?vue&type=template&id=64b6024c"
import script from "./compChannelConfig.vue?vue&type=script&lang=js"
export * from "./compChannelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports